import React from 'react';
import PropTypes from 'prop-types';

import './DemographicsCard.scss';
import { PageContext } from '../../../contexts/ContextCreator';
import { buildDefaultDiversityFlowState } from '../../Modals/Flows/DiversityInput/constants';
import { diversityInputFlowType } from '../../Modals/Flows/DiversityInput/DiversityInput';
import {
    serializeRawDemoInfoToFlowState,
    checkIsDemoFormFilled,
} from '../../Modals/Flows/DiversityInput/constants';

export default class DemographicsCard extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            demoInfoFilled: checkIsDemoFormFilled(props),
            serializedDemoInfo: serializeRawDemoInfoToFlowState(props),
        };
    }

    static propTypes = {
        /**
         * options for multiselecting ethnicity
         */
        ethnicityOptions: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                title: PropTypes.string,
            })
        ),
        /**
         * options for multiselecting ethnicity
         */
        orientationOptions: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                title: PropTypes.string,
            })
        ),
        gender: PropTypes.string,
        ethnicity: PropTypes.array,
        sexualOrientation: PropTypes.array,
        veteran: PropTypes.string,
        disability: PropTypes.string,
        otherComments: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                type: PropTypes.string,
                comment: PropTypes.string,
            })
        ),
    };

    static defaultProps = {
        ethnicityOptions: [],
        orientationOptions: [],
        gender: '',
        ethnicity: [],
        sexualOrientation: [],
        veteran: '',
        disability: '',
        otherComments: [],
    };

    static contextType = PageContext;

    renderEmptyView = () => {
        return (
            <div className="demoContainer emptyview">
                <h4 className="title">Diversity matters.</h4>
                <button
                    type="button"
                    className="demoLink"
                    onClick={this.triggerDiversityFlow}
                >
                    + Add demographics
                </button>
            </div>
        );
    };

    renderUpdateView = () => {
        return (
            <div className="demoContainer updateview">
                <button
                    type="button"
                    className="demoLink"
                    onClick={this.triggerDiversityFlow}
                >
                    Update demographics
                </button>
            </div>
        );
    };

    setDemoInfo = (demoInfo, ethnicityOptions, orientationOptions) => {
        this.setState({
            serializedDemoInfo: serializeRawDemoInfoToFlowState({
                ...demoInfo,
                ethnicityOptions,
                orientationOptions,
            }),
            demoInfoFilled: checkIsDemoFormFilled(demoInfo),
        });
    };

    triggerDiversityFlow = () => {
        const { triggerFlowModal } = this.context;
        const { ethnicityOptions, orientationOptions } = this.props;
        const { serializedDemoInfo } = this.state;

        const closeOptions = { backgroundExits: true, escapeExits: true };

        const modalProps = {
            stepPopulateProps: buildDefaultDiversityFlowState(
                serializedDemoInfo
            ),
            generalModalProps: {
                closeOptions,
                ethnicityOptions,
                orientationOptions,
                setDemoInfo: this.setDemoInfo,
            },
        };

        return triggerFlowModal(diversityInputFlowType, modalProps);
    };

    render() {
        const { demoInfoFilled } = this.state;

        const showBorder = demoInfoFilled ? '' : 'hasBorder';

        return (
            <div
                className={`component-CallToAction-DemographicsCard ${showBorder}`}
            >
                {demoInfoFilled
                    ? this.renderUpdateView()
                    : this.renderEmptyView()}
            </div>
        );
    }
}
